// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__WKoGz","emails":"CreateEditClinics_emails__22otv","emailTagLabel":"CreateEditClinics_emailTagLabel__mGc8o"};